const BODY_CATEGORIES = {
  FULL_BODY: 'Full Body',
  HANDS: 'Hands/Feet',
  FACE: 'Lips/Face/Teeth',
  LEGS: 'Legs/Stomach',
  UNDERARMS: 'Underarms',
};

export default BODY_CATEGORIES;
